<template>
  <v-page-content>
    <h2 class="mt-3">
      Ежегодный слёт учащихся
      <span class="no-wrap">&laquo;Газпром-классов&raquo;</span>
    </h2>
    <div class="d-flex justify-content-center align-items-center mt-3">
      <img src="/files/slet2026/banner.jpg"
           style="width: 100%; max-width: 600px; height: auto; border: none;">
    </div>
    <div class="mt-4">
      <div class="text-justify gathering-info">
        <p>
          В целях содействия эффективной профориентации учащихся «Газпром-классов», их мотивации на обучение по направлениям подготовки, востребованным в ПАО «Газпром», Департамент 715 (А.В. Шагов) ежегодно проводит слеты учащихся «Газпром-классов».
          В 2026 году в период с 30 марта по 3 апреля будет проведен IX Слет учащихся «Газпром-классов».
          Место проведения: г. Санкт-Петербург.
          Письмо в дочерние общества о проведении слета: исх. от 13.02.2026 № 07/15-459.
        </p>
        <div>
          Программа слета (возможна корректировка времени и отдельных мероприятий):
          <div class="pl-4">
            <a :href="`/files/slet2026/${project}`" target="_blank">
              <em :class="`fas fa-file-word`"></em>
              {{project}}
            </a>
          </div>
        </div>
        <div>Необходимые документы (оригиналы передаются представителям ООО «Газпром ВНИИГАЗ» по прибытии на слет): </div>
        <div class="pl-4">
          <div v-for="doc in docs" :key="doc[0]">
            <a :href="`/files/slet2026/${doc[0]}`" target="_blank">
              <em :class="`fas fa-file-${doc[1]}`"></em>
              {{doc[0]}}
            </a>
          </div>
        </div>
        <div>
          Контактные данные организаторов:
        </div>
        <div style="color: blue;">
          Анисимова Наталья Александровна,
          <a href="mailto:N_Anisimova@vniigaz.gazprom.ru" style="color: blue;">N_Anisimova@vniigaz.gazprom.ru</a>,
          тел. <a href="tel:+78127040404" style="color: blue;">(812) 704 04 04</a>,
          газ. (785) 40404;
        </div>
        <div style="color: blue;">
          Серкова Елена Михайловна,
          <a href="mailto:E_Serkova@vniigaz.gazprom.ru" style="color: blue;">E_Serkova@vniigaz.gazprom.ru</a>,
          тел.: <a href="tel:+73452545528" style="color: blue;">(3452) 54 55 28</a>,
          газ. (770) 25-528.
        </div>
        <strong class="mt-3 mb-1">
          В срок до 1 марта 2026 г. необходимо направить в адрес организаторов:
          <br>
          –Заполненные анкеты;
          <br>
          –Информацию о прибытии (дата, время, место - аэропорт/вокзал).
        </strong>
      </div>
    </div>
  </v-page-content>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'Gathering',
  components: {},
  data() {
    const docs = {
      medical: 'Перечень необходимых медицинских документов.docx',
      members: 'Анкета_для_участников_Слета_учащихся.docx',
      folowers: 'Анкета_для_сопровождающего_Слета_учащихся.docx',
      underage: 'Все_согласия_несовершеннолетние.docx',
      adult: 'Все согласия_совершеннолетние.docx'
    }
    return {
      project: 'Программа слета.docx',
      docs: _.mapValues(docs, (name) => {
        let file
        if (name.includes('.doc')) file = 'word'
        else if (name.includes('.xls')) file = 'excel'
        return [name, file]
      }),
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../sass/vendor/bootstrap/variables";

.no-wrap {
  white-space: nowrap; /* Запрещаем перенос текста */
}

.fa-file-word {
  color: $blue;
}

.fa-file-excel {
  color: $green;
}

.fa-file-pdf {
  color: $red;
}

.gathering-info {
  font-size: 1.15em;
}
</style>
